module.exports = __webpack_public_path__ + "assets/img/drawItem4-b15d7e40.png";